import { useIntl } from 'react-intl';
import { ApiMemberResponseRow } from '@agunity/api-v4';
import { Stack, Table, TableBody, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import Error from '@mui/icons-material/Error';
import Warning from '@mui/icons-material/Warning';

import { AgColor } from '../../../stories/Styles/AgColor';

import * as S from './styled';

const ErrorTable = ({ combinedErrors }: { combinedErrors: (ApiMemberResponseRow & { type: 'warning' | 'error' })[] }) => {
  const formatMessage = useIntl().formatMessage;

  const headers = [{
    field: 'type',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_ERROR_TABLE_TYPE' }),
    width: 130,
  },
  {
    field: 'id',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_ERROR_TABLE_ID' }),
    width: 80,
  },
  {
    field: 'description',
    headerName: formatMessage({ id: 'BULK_UPLOAD_REQUEST_ERROR_TABLE_DESCRIPTION' }),
  }];

  return (
    <TableContainer>
      <Table sx={{ borderTop: `1px solid ${AgColor.grey4}`, borderLeft: `1px solid ${AgColor.grey4}`, }}>
        <TableHead>
          <TableRow>
            {
              headers?.map((header) => (
                <S.StyledTableCell key={header.field} width={header.width}>{header.headerName || ''}</S.StyledTableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {combinedErrors.map((error, index) => {
            const isWarning = error.type === 'warning';
            const name = [error.sheetName, error.name].filter(Boolean).join('/');
            const icon = (
              <Tooltip title={
                isWarning
                  ? formatMessage({ id: 'BULK_UPLOAD_REQUEST_WARNING_ISSUE' })
                  : formatMessage({ id: 'BULK_UPLOAD_REQUEST_ERROR_ISSUE' })}
              >
                {isWarning
                  ? <Warning fontSize='small' color='warning' />
                  : <Error fontSize='small' color='error' />}
              </Tooltip>
            );

            return (
              <TableRow key={index}>
                <S.StyledTableCell>
                  <Stack direction='row' gap={1} alignItems='center' style={{ textAlign: 'left' }}>
                    {icon}
                    {name}
                  </Stack>
                </S.StyledTableCell>
                <S.StyledTableCell style={{ textAlign: 'left' }}>{formatMessage({ id: 'BULK_UPLOAD_REQUEST_ROW_ID' }, { row: error.row })}</S.StyledTableCell>
                <S.StyledTableCell style={{ textAlign: 'left' }}>{error.issue}</S.StyledTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ErrorTable;